// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"8":"mobile","535":"login","603":"payment-status","764":"payment","860":"menu"}[chunkId] + "." + {"8":"8e4b3615","535":"3b80d088","603":"1f386dc4","764":"d34aceb2","860":"9f2bfebd"}[chunkId] + ".js";
};